module.exports = __webpack_public_path__ + "static/media/Dpocsai_Resume.9552fb7a.PDF";